// mian list for farm

export default [
  {
    id: "HUSD",
    token_symbol: "HUSD",
    item_icon: "husd.png",
    item_icon_2: "",
    token_address: "0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0xd4df5d9e476432f5d23ce00859cffbf2b0954185",
    apy: "-",
    start_time: {
      en: "9am, Jan 27, 2021 (EST)",
      zh: "2021 01-27 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "HBTC",
    token_symbol: "HBTC",
    item_icon: "hbtc.png",
    item_icon_2: "",
    token_address: "0x66a79D23E58475D2738179Ca52cd0b41d73f0BEa",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x829a730777b047bf46e566a9e10a11c98c2d20ef",
    apy: "-",
    start_time: {
      en: "9am, Jan 27, 2021 (EST)",
      zh: "2021 01-27 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 50682.2
  },

  {
    id: "HPT",
    token_symbol: "HPT",
    item_icon: "hpt.png",
    item_icon_2: "",
    token_address: "0xe499ef4616993730ced0f31fa2703b92b50bb536",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x16750e037374a794938825af060b2475df712bd0",
    apy: "-",
    start_time: {
      en: "9am, Jan 27, 2021 (EST)",
      zh: "2021 01-27 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.0174,
  },

  {
    id: "HT",
    token_symbol: "HT",
    item_icon: "ht.png",
    item_icon_2: "",
    token_address: "",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x4e6f9f842d81e1471efb33ee2c3157331f49bf30",
    apy: "-",
    start_time: {
      en: "9am, Jan 28, 2021 (EST)",
      zh: "2021 01-28 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 19.44,
  },

  {
    id: "ETH",
    token_symbol: "ETH",
    item_icon: "eth.png",
    item_icon_2: "",
    token_address: "0x64FF637fB478863B7468bc97D30a5bF3A428a1fD",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x41e49031680cf425322232deebe9a7732963438a",
    apy: "-",
    start_time: {
      en: "7am, Feb 02, 2021 (EST)",
      zh: "2021 02-02 20:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1464.33,
  },

  {
    id: "HDOT",
    token_symbol: "HDOT",
    item_icon: "dot.png",
    item_icon_2: "",
    token_address: "0xa2c49cee16a5e5bdefde931107dc1fae9f7773e3",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x090fc08fd93b4ddeab5522d6c7d2b7a91ba562cb",
    apy: "-",
    start_time: {
      en: "7am, Feb 02, 2021 (EST)",
      zh: "2021 02-02 20:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 33.81,
  },

  {
    id: "LAVA",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662e71f30b333b456439248c6de589082a4",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x7e7766fcf7e6e7c361735fef786b5da6b8f65c93",
    apy: "-",
    start_time: {
      en: "7am, Feb 02, 2021 (EST)",
      zh: "2021 02-02 20:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "USDT",
    token_symbol: "USDT",
    item_icon: "usdt.png",
    item_icon_2: "",
    token_address: "0xa71EdC38d189767582C38A3145b5873052c3e47a",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0xa9ae0e527758d7c5c2818749eb291e02ca00291a",
    apy: "-",
    start_time: {
      en: "10pm, Feb 04, 2021 (EST)",
      zh: "2021 02-05 11:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "GENE",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "GENE",
    // 合约地址
    reward_address: "0x7151fd61c74fe0e7a06ad0c56d252a30245fbee2",
    apy: "-",
    start_time: {
      en: "7am, Mar 01, 2021 (EST)",
      zh: "2021 03-01 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "SKM",
    token_symbol: "SKM",
    item_icon: "skm.png",
    item_icon_2: "",
    token_address: "0x96674f8da3F9c6ACb4A56b393AF9A490D70D16d0",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x93adc24f4201dbe441ebbf9475d709240da4ae4d",
    apy: "-",
    start_time: {
      en: "9am, Feb 12, 2021 (EST)",
      zh: "2021 02-12 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.007068,
  },

  {
    id: "LAVA3",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "FOMP",
    // 合约地址
    reward_address: "0xEcD6967a0F523c335dd61A10558f10ACa0c590e0",
    apy: "-",
    start_time: {
      en: "8am, Mar 08, 2021 (EST)",
      zh: "2021 03-08 21:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.65,
  },

  {
    id: "TPT2",
    token_symbol: "TPT",
    item_icon: "tpt.png",
    item_icon_2: "",
    token_address: "0x9ef1918a9beE17054B35108bD3E2665e2Af1Bb1b",
    //token_decimals: 18,
    token_earn_symbol: "FOMP",
    // 合约地址
    reward_address: "0xFe1F1fA12135f5685CC72D09276cb78CC0ed3B70",
    apy: "-",
    start_time: {
      en: "8am, Mar 08, 2021 (EST)",
      zh: "2021 03-08 21:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.0321,
  },

  {
    id: "LAVA4",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "Hoo",
    // 合约地址
    reward_address: "0x01C4D5e345bb16dDfacD617458d521160404d1dB",
    apy: "-",
    start_time: {
      en: "9am, Mar 14, 2021 (EST)",
      zh: "2021 03-014 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.3154,
  },

  {
    id: "HBTC2",
    token_symbol: "HBTC",
    item_icon: "hbtc.png",
    item_icon_2: "",
    token_address: "0x66a79D23E58475D2738179Ca52cd0b41d73f0BEa",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x3cce6e22d7dc39f5499539a3199b29e26bc287ff",
    apy: "-",
    start_time: {
      en: "10pm, Mar 04, 2021 (EST)",
      zh: "2021 03-05 11:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 61682.2
  },

  {
    id: "ETH2",
    token_symbol: "ETH",
    item_icon: "eth.png",
    item_icon_2: "",
    token_address: "0x64FF637fB478863B7468bc97D30a5bF3A428a1fD",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0xa33aa612101ecf533da40dad0a49ab7eb9fd3358",
    apy: "-",
    start_time: {
      en: "10pm, Mar 04, 2021 (EST)",
      zh: "2021 03-05 11:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1905.33,
  },

  {
    id: "HT2",
    token_symbol: "HT",
    item_icon: "ht.png",
    item_icon_2: "",
    token_address: "",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0xe392e82f2ddcf7642052af1b251443b96d11112b",
    apy: "-",
    start_time: {
      en: "10pm, Mar 04, 2021 (EST)",
      zh: "2021 03-05 11:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 15.44,
  },

  {
    id: "USDT2",
    token_symbol: "USDT",
    item_icon: "usdt.png",
    item_icon_2: "",
    token_address: "0xa71EdC38d189767582C38A3145b5873052c3e47a",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0xc5d787ea3c0881bfc0e28c63e21c3237668c90af",
    apy: "-",
    start_time: {
      en: "10pm, Mar 04, 2021 (EST)",
      zh: "2021 03-05 11:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "LAVA-REC",
    token_symbol: "LAVA-REC",
    item_icon: "lava.png",
    item_icon_2: "rec.png",
    token_address: "0x2Bf716802504beD8080D8816c29A8e3C5af3eab4",
    //token_decimals: 18,
    token_earn_symbol: "GENE",
    // 合约地址
    reward_address: "0x4a0124f5fcc87d044d786db013c95f8609c6c028",
    apy: "-",
    start_time: {
      en: "7am, Mar 02, 2021 (EST)",
      zh: "2021 03-02 20:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },


  {
    id: "MX",
    token_symbol: "MX",
    item_icon: "mx.png",
    item_icon_2: "",
    token_address: "0x48C1D1f0d5281FbB0bec2E699846fA615d55f3D4",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x8058d7f817e8701856686B139f6574E1A6D73992",
    apy: "-",
    start_time: {
      en: "9am, Mar 08, 2021 (EST)",
      zh: "2021 03-08 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.63,
  },


  {
    id: "HUSD2",
    token_symbol: "HUSD",
    item_icon: "husd.png",
    item_icon_2: "",
    token_address: "0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x55A718374aab282c43C46517a04bed17827dcf9b",
    apy: "-",
    start_time: {
      en: "8am, Mar 08, 2021 (EST)",
      zh: "2021 03-08 21:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },


  {
    id: "GENE2",
    token_symbol: "GENE",
    item_icon: "gene.png",
    item_icon_2: "",
    token_address: "0x2CFa849e8506910b2564aFE5BdEF33Ba66C730Aa",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0xf7e4B85903e8DC9047262cB419eF249e07ec139D",
    apy: "-",
    start_time: {
      en: "10am, Mar 11, 2021 (EST)",
      zh: "2021 03-011 21:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.0219,
  },

  {
    id: "LAVA5",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "Hoo",
    // 合约地址
    reward_address: "0xc9E553A9D9E78E5E8476655bcE2f34291dd7F473",
    apy: "-",
    start_time: {
      en: "8am, Mar 15, 2021 (EST)",
      zh: "2021 03-15 21:00:00 UTC+8"
    },
    des_earn_per_day: 2000,
    price_on_usd: 0,
  },
  
  {
    id: "HOO",
    token_symbol: "Hoo",
    item_icon: "hoo.png",
    item_icon_2: "",
    token_address: "0xE1d1F66215998786110Ba0102ef558b22224C016",
    //token_decimals: 18,
    token_earn_symbol: "Lava",
    // 合约地址
    reward_address: "0x3591B79Ef267bBd63c8dfe8210dc60cD225c74e2",
    apy: "-",
    start_time: {
      en: "9am, Mar 14, 2021 (EST)",
      zh: "2021 03-14 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.3154,
  },

  {
    id: "JT",
    token_symbol: "JT",
    item_icon: "jt.png",
    item_icon_2: "",
    token_address: "0xC0eCC17C6C87B32b2a86D9F4a783974cB1e6507C",
    //token_decimals: 18,
    token_earn_symbol: "Lava",
    // 合约地址
    reward_address: "0x4Fc976984765B3299d25818a79bE93E0cD144812",
    apy: "-",
    start_time: {
      en: "10am, Mar 16, 2021 (EST)",
      zh: "2021 03-16 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.2,
  },

  {
    id: "LHB",
    token_symbol: "LHB",
    item_icon: "lhb.png",
    item_icon_2: "",
    token_address: "0x8F67854497218043E1f72908FFE38D0Ed7F24721",
    //token_decimals: 18,
    token_earn_symbol: "Lava",
    // 合约地址
    reward_address: "0x5F7359Ed7e857571C802d153F8FE2216DA04eeC4",
    apy: "-",
    start_time: {
      en: "10am, Mar 16, 2021 (EST)",
      zh: "2021 03-16 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.37,
  },
  
  {
    id: "ITF-LAVA",
    token_symbol: "ITF-LAVA",
    item_icon: "itf.png",
    item_icon_2: "lava.png",
    token_address: "0xeEEdCf711187BbAA57ffc0BeEA31b0A50d91E0c0",
    //token_decimals: 18,
    token_earn_symbol: "ITF-LAVA",
    // 合约地址
    reward_address: "0x64FfCa50e53624E630ea260165Ba9D58C7C77cAa",
    apy: "-",
    start_time: {
      en: "10am, Mar 25, 2021 (EST)",
      zh: "2021 03-25 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "ITF-ETH",
    token_symbol: "ITF-ETH",
    item_icon: "itf.png",
    item_icon_2: "eth.png",
    token_address: "0x954Eac303a717c47e40397bb17CC3B81ee88F555",
    //token_decimals: 18,
    token_earn_symbol: "ITF-LAVA",
    // 合约地址
    reward_address: "0xC92963759F7549023a900d1B114a9d61AD9d2ED3",
    apy: "-",
    start_time: {
      en: "10am, Mar 25, 2021 (EST)",
      zh: "2021 03-25 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "LAVA2",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x90423264d747a620d64b897e21c02bd5105f7789",
    apy: "-",
    start_time: {
      en: "7am, Mar 02, 2021 (EST)",
      zh: "2021 03-02 20:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "HBC",
    token_symbol: "HBC",
    item_icon: "hbc.png",
    item_icon_2: "",
    token_address: "0x894b2917c783514c9e4c24229bF60f3Cb4c9c905",
    //token_decimals: 18,
    token_earn_symbol: "Lava",
    // 合约地址
    reward_address: "0xAA5a8a2f530963f0fc36C6094Bc2242Dff772B75",
    apy: "-",
    start_time: {
      en: "10am, Mar 18, 2021 (EST)",
      zh: "2021 03-18 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 14.14,
  },

  {
    id: "FilDA-USDT-FilDA-LAVA",
    token_symbol: "FilDA-USDT",
    item_icon: "filda.png",
    item_icon_2: "usdt.png",
    token_address: "0x961d2b834b403a097247d8e557d26a6c72b1a99c",
    //token_decimals: 18,
    token_earn_symbol: "FilDA-LAVA",
    // 合约地址
    reward_address: "0xDa727832A0d9F11bC860cB7549D89c1584111567",
    apy: "-",
    start_time: {
      en: "10am, Mar 19, 2021 (EST)",
      zh: "2021 03-19 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "LAVA6",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "ITF",
    // 合约地址
    reward_address: "0xCa8C4Ed0Ba934A75b5bC0A07b98a0dc01eef532C",
    apy: "-",
    start_time: {
      en: "10am, Mar 24, 2021 (EST)",
      zh: "2021 03-24 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 11.04,
  },


  {
    id: "ITF",
    token_symbol: "ITF",
    item_icon: "itf.png",
    item_icon_2: "",
    token_address: "0x943D97ad0b597F73425d6f740596D0efD3d62507",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x30BF4d14CdF8EE62548ea5B5d541ABE83Cadd39C",
    apy: "-",
    start_time: {
      en: "10am, Mar 24, 2021 (EST)",
      zh: "2021 03-24 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 11.04,
  },

  {
    id: "FOMP-TPT",
    token_symbol: "FOMP-TPT",
    item_icon: "fomp.png",
    item_icon_2: "tpt.png",
    token_address: "0x27933EF78129EceE3e048055B1E0fB9d136d415E",
    //token_decimals: 18,
    token_earn_symbol: "FOMP",
    // 合约地址
    reward_address: "0xe9503aa48f3Cb0e540c64cdd00848c29A2720BE5",
    apy: "-",
    start_time: {
      en: "10am, Mar 11, 2021 (EST)",
      zh: "2021 03-011 21:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 36.05,
  },

  {
    id: "FOMP-USDT",
    token_symbol: "FOMP-USDT",
    item_icon: "fomp.png",
    item_icon_2: "usdt.png",
    token_address: "0x1b24D4179070a2a79be891d9E64649446a043309",
    //token_decimals: 18,
    token_earn_symbol: "FOMP",
    // 合约地址
    reward_address: "0x9428b5ACe2B3a427Ba44A1183eCc779df6631a29",
    apy: "-",
    start_time: {
      en: "10am, Mar 11, 2021 (EST)",
      zh: "2021 03-011 21:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 36.05,
  },

  {
    id: "FOMA-USDT",
    token_symbol: "FOMA-USDT",
    item_icon: "foma.png",
    item_icon_2: "usdt.png",
    token_address: "0x6A32EdCb7C4b4F531d228f408aDFA95Da5d0a2ae",
    //token_decimals: 18,
    token_earn_symbol: "FOMP",
    // 合约地址
    reward_address: "0xEe90Be0Fa394f3C18e14eD4096A3F99f3Ddac11F",
    apy: "-",
    start_time: {
      en: "10am, Mar 11, 2021 (EST)",
      zh: "2021 03-011 21:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 36.05,
  },

  {
    id: "SATO1",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "SATO",
    // 合约地址
    reward_address: "0xfd00EcFb2958D90eEd0e24de9dB1eBA60FA53534",
    apy: "-",
    start_time: {
      en: "10am, Apr 02, 2021 (EST)",
      zh: "2021 04-02 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "SATO2",
    token_symbol: "USDT",
    item_icon: "usdt.png",
    item_icon_2: "",
    token_address: "0xa71EdC38d189767582C38A3145b5873052c3e47a",
    //token_decimals: 18,
    token_earn_symbol: "SATO",
    // 合约地址
    reward_address: "0x488e5ababcAaa2D43C31b9f342c36c3ee9a8CC9b",
    apy: "-",
    start_time: {
      en: "10am, Apr 02, 2021 (EST)",
      zh: "2021 04-02 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },


  {
    id: "VIBK-NULS",
    token_symbol: "VIBK-NULS",
    item_icon: "vibk.png",
    item_icon_2: "nuls.png",
    token_address: "0xe99832350ac4d3401cd49ceef8765d71a627288f",
    //token_decimals: 18,
    token_earn_symbol: "VIBK",
    // 合约地址
    reward_address: "0x263B2612D60061e7c877028f037837214CBb5fA8",
    apy: "-",
    start_time: {
      en: "10am, Apr 06, 2021 (EST)",
      zh: "2021 04-06 22:00:00 UTC+8"
    },
    second_title:{
      en:'NULS',
      zh:'NULS合作专区'
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },


  {
    id: "VIBK-LAVA",
    token_symbol: "VIBK-LAVA",
    item_icon: "vibk.png",
    item_icon_2: "lava.png",
    token_address: "0x666267fffefd5452605803567b57832a65fe74bc",
    //token_decimals: 18,
    token_earn_symbol: "VIBK",
    // 合约地址
    reward_address: "0x0004D34997Fe9ab10fD4AB889D16f87f38912330",
    apy: "-",
    start_time: {
      en: "10am, Apr 06, 2021 (EST)",
      zh: "2021 04-06 22:00:00 UTC+8"
    },
    second_title:{
      en:'NULS',
      zh:'NULS合作专区'
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "LAVA7",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x13B453E4bEB8A9d80c91e7f33053Cb8193E33Ac2",
    apy: "-",
    start_time: {
      en: "8am, Apr 01, 2021 (EST)",
      zh: "2021 04-01 20:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 1,
  },

  {
    id: "DATT-NULS",
    token_symbol: "DATT-NULS",
    item_icon: "datt.png",
    item_icon_2: "nuls.png",
    token_address: "0xf0d134aad095173eea6c48eb1dbb49c8341ab9d9",
    //token_decimals: 18,
    token_earn_symbol: "DATT",
    // 合约地址
    reward_address: "0x3d2E199265525451C3c38546fdD436C176BfA4e7",
    apy: "-",
    start_time: {
      en: "10am, Apr 13, 2021 (EST)",
      zh: "2021 04-13 22:00:00 UTC+8"
    },
    second_title:{
      en:'NULS',
      zh:'NULS合作专区'
    },
    des_earn_per_day: 0,
    price_on_usd: 0.02,
  },

  {
    id: "DATT-USDT",
    token_symbol: "DATT-USDT",
    item_icon: "datt.png",
    item_icon_2: "usdt.png",
    token_address: "0xf121c6ba2852679426e2dcf56eeb7f0a30b05a05",
    //token_decimals: 18,
    token_earn_symbol: "DATT",
    // 合约地址
    reward_address: "0x5E452d9982DFd399999b32D0356206F58C8891bc",
    apy: "-",
    start_time: {
      en: "10am, Apr 13, 2021 (EST)",
      zh: "2021 04-13 22:00:00 UTC+8"
    },
    second_title:{
      en:'NULS',
      zh:'NULS合作专区'
    },
    des_earn_per_day: 0,
    price_on_usd: 0.02,
  },

  {
    id: "LAVA8",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "DATT",
    // 合约地址
    reward_address: "0xB6bbe659CafCbdAbbA8e51E07b52eFCe209a3167",
    apy: "-",
    start_time: {
      en: "10am, Apr 12, 2021 (EST)",
      zh: "2021 04-12 22:00:00 UTC+8"
    },
    second_title:{
      en:'NULS',
      zh:'NULS合作专区'
    },
    des_earn_per_day: 0,
    price_on_usd: 0.02,
  },

  {
    id: "SATO-USDT",
    token_symbol: "SATO-USDT",
    item_icon: "sato.png",
    item_icon_2: "usdt.png",
    token_address: "0x1587064250B32593AC8b9190fc38792eeC9FE85d",
    //token_decimals: 18,
    token_earn_symbol: "SATO",
    // 合约地址
    reward_address: "0xA49B09b89D12f3fDdcD79988360bbbc9b37Ee466",
    apy: "-",
    start_time: {
      en: "9pm, Apr 15, 2021 (EST)",
      zh: "2021 04-16 09:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 2.156,
  },

  {
    id: "LAVA9",
    token_symbol: "LAVA",
    item_icon: "lava.png",
    item_icon_2: "",
    token_address: "0x56f95662E71f30b333b456439248c6dE589082a4",
    //token_decimals: 18,
    token_earn_symbol: "ARCH",
    // 合约地址
    reward_address: "0x856103f759be1c18fA642247544F29BA2C1605E0",
    apy: "-",
    start_time: {
      en: "10am, Apr 22, 2021 (EST)",
      zh: "2021 04-22 22:00:00 UTC+8"
    },
    des_earn_per_day: 0,
    price_on_usd: 0.011,
  },

  {
    id: "ARCH-USDT",
    token_symbol: "ARCH-USDT",
    item_icon: "arch.png",
    item_icon_2: "usdt.png",
    token_address: "0xEEc243468cc46381bb1aB38214EC7131f6121e50",
    //token_decimals: 18,
    token_earn_symbol: "ARCH",
    // 合约地址
    reward_address: "0x8170E35C9676dcba9263ED612fd23871C0611f69",
    apy: "-",
    start_time: {
      en: "10am, Apr 24, 2021 (EST)",
      zh: "2021 04-24 22:00:00 UTC+8"
    },
    des_earn_per_day:0,
    price_on_usd: 0.011,
  },

];